import { render } from "./ProductPromotion.vue?vue&type=template&id=94b07fae&lang=pug"
import script from "./ProductPromotion.vue?vue&type=script&lang=js"
export * from "./ProductPromotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__